import { msg } from '@lingui/core/macro';

export const SHARED_LEARNING_CARD_COMPLETED = msg`Completed`;
export const SHARED_LEARNING_CARD_RESUME_NOW = msg`Resume now`;
export const SHARED_LEARNING_CARD_BUTTON_TEXT = msg`Start`;
export const SHARED_LEARNING_CARD_RE_DO = msg`Re-do`;

export const SHARED_LEARNING_TAB_SHOW_MORE = msg`Show more`;
export const SHARED_LEARNING_TAB_SHOW_LESS = msg`Show less`;
export const SHARED_LEARNING_TAB_NO_LEARNINGS = msg`No learnings`;
export const SHARED_LEARNING_TAB_NO_LEARNINGS_DESCRIPTION = msg`Provided criteria doesnt match with your learnings`;
export const SHARED_LEARNING_TAB_PATHWAYS_AVAILABLE = msg`pathways available`;
